// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nn8s6WdW2RxxyBmAmE2Si"};